import React, {useState} from 'react'
import styled from 'styled-components'

const MAX_VISIBLE_FAILURES = 3

const Content = styled.div`
  strong {
    font-weight: 600;
  }
  li {
    margin-top: .15rem;
  }
`

const List = styled.ul`
  list-style: none;
  margin: .35rem 0 0;
  padding: 0;
`

const ToggleLink = styled.a`
  display: inline-block;
  margin-top: .5rem;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
`

// Renders one line per failed record (instead of the default single-line Errors item), with an
// expand/collapse toggle when there are more failures than fit comfortably in the box.
export const DeleteFailuresMessage = ({failures}) => {
  const [expanded, setExpanded] = useState(false)
  const visible = expanded ? failures : failures.slice(0, MAX_VISIBLE_FAILURES)
  const hiddenCount = failures.length - visible.length

  return (
    <Content>
      <strong>{failures.length > 1 ? `Failed to delete ${failures.length} files:` : 'Failed to delete:'}</strong>
      <List>
        {visible.map(({label, message}, i) => <li key={i}>{label} - {message}</li>)}
      </List>
      {hiddenCount > 0 && <ToggleLink onClick={() => setExpanded(true)}>Show {hiddenCount} more</ToggleLink>}
      {expanded && failures.length > MAX_VISIBLE_FAILURES &&
        <ToggleLink onClick={() => setExpanded(false)}>Show less</ToggleLink>}
    </Content>
  )
}


